import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronLeft, ChevronRight, ClipboardList, FileSearch, UserCheck, User, LogOut, Settings, Map } from 'lucide-react';
import UserProfile from "./UserProfile";
import LogoNSSA from "./LogoNSSA";
const version = __APP_VERSION__;

const Sidebar = ({ mobileOpen = false, onCloseMobile }) => {
  const [menuStates, setMenuStates] = useState({});
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    document.body.classList.toggle("sidebar-icon-only");
    setIsCollapsed((prev) => !prev);
  };
  const location = useLocation();

  const user = UserProfile.getInstance();
  const hasInspectorShowPermisson = user.hasInspectorShowPermisson();
  const hasInspectionShowPermisson = user.hasInspectionShowPermisson();
  const hasEmvRole = user.hasEmvRole();
  const hasSupervisorABMRole = user.hasSupervisorABMRole();
  const canViewMap = user.canViewMap();
  const pathSupervisor = "/supervisor-abm";

  const isPathActive = (path) => location.pathname.startsWith(path);

  const toggleMenuState = (menuState) => {
    const newStates = Object.keys(menuStates).reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {});
    setMenuStates({
      ...newStates,
      [menuState]: !menuStates[menuState],
    });
  };

  const onRouteChanged = () => {
    document.querySelector("#sidebar")?.classList.remove("active");

    const dropdownPaths = [
      { path: "config", state: "configOpen" },
      { path: "reports", state: "reportsOpen" },
    ];

    const newStates = dropdownPaths.reduce((acc, obj) => {
      acc[obj.state] = isPathActive(obj.path);
      return acc;
    }, {});
    setMenuStates(newStates);
  };

  useEffect(() => {
    onRouteChanged();
  }, [location]);

  useEffect(() => {


    const body = document.querySelector("body");
    const navItems = document.querySelectorAll(".sidebar .nav-item");

    const listeners = Array.from(navItems).map((el) => {
      const onMouseOver = () => {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      };
      const onMouseOut = () => {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      };
      el.addEventListener("mouseover", onMouseOver);
      el.addEventListener("mouseout", onMouseOut);
      return { el, onMouseOver, onMouseOut };
    });

    return () => {
      listeners.forEach(({ el, onMouseOver, onMouseOut }) => {
        el.removeEventListener("mouseover", onMouseOver);
        el.removeEventListener("mouseout", onMouseOut);
      });
    };
  }, []);

  return (
    <nav
      className={`sidebar sidebar-offcanvas${mobileOpen ? ' mobile-open' : ''}`}
      id="sidebar"

    >
      <div className="sidebar-brand-wrapper">
        <Link className="sidebar-brand brand-logo" to="/">
          <LogoNSSA isotipoOnly={false} />
        </Link>
        <Link className="sidebar-brand brand-logo-mini" to="/">
          <LogoNSSA isotipoOnly={true} />
        </Link>
        <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
          <i className={`mdi mdi-chevron-${isCollapsed ? "right" : "left"}`} />
        </button>
      </div>

      <ul className="nav">
        {hasInspectorShowPermisson && (
          <li
            className={
              isPathActive("/inspectores") ? "nav-item active" : "nav-item"
            }
          >
            <Link
              className={
                isPathActive("/inspectores") ? "nav-link active" : "nav-link"
              }
              to="/inspectores"
            >
              {/* <i className="mdi mdi-account-check menu-icon"></i> */}
              <UserCheck size={20} />
              <span className="menu-title">Inspectores</span>
            </Link>
          </li>
        )}

        {hasInspectionShowPermisson && (
          <li
            className={
              isPathActive("/inspecciones") ? "nav-item active" : "nav-item"
            }
          >
            <Link
              className={
                isPathActive("/inspecciones") ? "nav-link active" : "nav-link"
              }
              to="/inspecciones"
            >
              {/* <i className="mdi mdi-file-search menu-icon"></i> */}
              <FileSearch size={20} />
              <span className="menu-title">Inspecciones</span>
            </Link>
          </li>
        )}

        {canViewMap && (
          <li
            className={
              isPathActive("/mapa") ? "nav-item active" : "nav-item"
            }
          >
            <Link
              className={
                isPathActive("/mapa") ? "nav-link active" : "nav-link"
              }
              to="/mapa"
            >
              <Map size={20} />
              <span className="menu-title">Mapa</span>
            </Link>
          </li>
        )}

        {hasEmvRole && (
          <li className={isPathActive("/emv") ? "nav-item active" : "nav-item"}>
            <Link
              className={isPathActive("/emv") ? "nav-link active" : "nav-link"}
              to="/emv"
            >
              <i className="mdi mdi-credit-card menu-icon"></i>
              <span className="menu-title">EMV (Tj. Débito/Crédito)</span>
            </Link>
          </li>
        )}

        {hasSupervisorABMRole && (
          <li
            className={
              isPathActive(pathSupervisor) ? "nav-item active" : "nav-item"
            }
          >
            <Link
              className={
                isPathActive(pathSupervisor) ? "nav-link active" : "nav-link"
              }
              to={pathSupervisor}
            >
              {/* <i className="mdi mdi-clipboard-list menu-icon"></i> */}
              <ClipboardList size={20} />
              <span className="menu-title">Supervisor ABM</span>
            </Link>
          </li>
        )}
      </ul>

      <div className="sidebar-version">
        <p>v{version}</p>
      </div>
    </nav>
  );
};

export default Sidebar;
